import { MultiselectCommand } from '../../core/model/command';

export const articleCommand = {
  export: 'export',
};

export class ArticleMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);
  }
}
